import FullLogo from "./logos/full.png";
import SignLogo from "./logos/sign.png";

export const Logos = {
  Full: FullLogo,
  Sign: SignLogo,
};
